import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import {
  DEFAULT_EDITOR_SETTINGS,
  loadEditorSettings,
  persistEditorSettings,
  type EditorSettings,
} from "./editor-settings";

/**
 * Hydration-safe editor settings state — server render uses defaults, the
 * persisted value applies after mount, and every change is written back.
 */
export function useEditorSettingsState(): [
  EditorSettings,
  Dispatch<SetStateAction<EditorSettings>>,
] {
  const [editorSettings, setEditorSettings] = useState<EditorSettings>(DEFAULT_EDITOR_SETTINGS);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setEditorSettings(loadEditorSettings());
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    persistEditorSettings(editorSettings);
  }, [editorSettings, hydrated]);

  return [editorSettings, setEditorSettings];
}
